export default {
  Field: 1, //Lĩnh vực
  Content: 0, //Nội dung
};
